import React from 'react';
import { Users, Award, Gift } from 'lucide-react';
export function BridgeportProgramsPricing() {
  const programs = [{
    icon: Users,
    name: 'Taekwondo',
    description: 'Traditional Korean martial art for all ages and skill levels',
    pricing: 'First 2 weeks FREE',
    highlight: true
  }, {
    icon: Award,
    name: 'Tang Soo Do',
    description: 'Korean martial art emphasizing striking and traditional forms',
    pricing: 'First 2 weeks FREE',
    highlight: true
  }];
  return <section className="py-16 bg-slate-50" data-id="element-485">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-486">
        <div className="text-center mb-12" data-id="element-487">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-488">
            Programs & Pricing
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-489">
            Experience traditional martial arts training with our expert
            instructors in a community-focused environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-8" data-id="element-490">
          {programs.map((program, index) => <div key={index} className="bg-white rounded-xl border-2 border-[#dc2626] shadow-md p-6 text-center" data-id="element-491">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-[#dc2626] rounded-full mb-4" data-id="element-492">
                <program.icon className="h-6 w-6 text-white" data-id="element-493" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-494">
                {program.name}
              </h3>
              <p className="text-sm text-slate-600 mb-4" data-id="element-495">
                {program.description}
              </p>
              <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-bold bg-[#dc2626] text-white" data-id="element-496">
                <Gift className="h-4 w-4 mr-2" data-id="element-497" />
                {program.pricing}
              </div>
            </div>)}
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 text-center" data-id="element-498">
          <p className="text-slate-600" data-id="element-499">
            <span className="font-bold text-[#1a2332]" data-id="element-500">Special Offer:</span> Get
            your first 2 weeks FREE for both Taekwondo and Tang Soo Do!
            Experience traditional martial arts training with no commitment.
          </p>
        </div>
      </div>
    </section>;
}